<template>
    <div v-if="modalAlert" class="alert-modal toggle-alert">
        <div class="alert-modal-container">
            <div class="modal-content">
                <div id="alert-modal" class="card bg-orange-gradLight">
                    <button class="btn-close" @click="onCancel">
                        <img :src="close" alt="close" />
                    </button>

                    <div class="card-body">
                        <div class="mensages-container">
                            <img
                                :src="success"
                                alt="success"
                                class="message-img"
                            />
                            <h1>
                                A tua opinião faz toda a diferença
                            </h1>
                            <p v-if="message == 1">
                                Avalia a encomenda e ajuda-nos a oferecer <br/>
                                um serviço ainda melhor.
                            </p>
                            <p v-if="message == 2">
                                Tens avaliações pendentes! Partilha <br/>
                                a tua opinião.
                            </p>

                            <div class="modal-bottom single">
                                <div class="text-center">
                                    <button class="btn-bg" @click="onConfirm" v-text="message == 1 ? ` Ok ` : `Histórico de encomendas`">
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import icClose from "../../svg/ic_close_orange.svg";
import icSuccess from "../../svg/ic_success.svg";

export default {
    props: {
        modalReviewsIntro: {
            required: true,
        },
        modalReviewsPending: {
            required: true,
        },
    },

    data() {
        return {
            close: icClose,
            success: icSuccess,
            modalAlert: false,
            message: 1,
            lastOrder: 0,
        };
    },
    methods: {
        modalAlertHandler() {
            this.modalAlert = !this.modalAlert;

            document.querySelector("html").classList.toggle("no-scroll");
            document.querySelector("body").classList.toggle("no-scroll");
        },
        onConfirm() {
            Livewire.emit('setModalReviews', 'confirm', this.message, this.lastOrder);
            this.modalAlertHandler();
        },
        onCancel() {
            Livewire.emit('setModalReviews', 'cancel', this.message, this.lastOrder);
            this.modalAlertHandler();
        }
    },
    created() {
        // Message 1
        if(!this.modalReviewsIntro){
            this.modalAlertHandler();
            return;
        }

        // Message 2
        this.$axios.get(`/reviews/pending`).then(({data}) => {
            if(data.pendingReviews > 0 && this.modalReviewsPending != data.lastOrder){
                this.message = 2;
                this.lastOrder = data.lastOrder;
                this.modalAlertHandler();
            }
        });
    }
};
</script>

<style></style>
